import styled from 'styled-components';
import PageContainer from '../../components/PageContainer';

const StyledVendorsPageContainer = styled(PageContainer)`
  & > {
    .ant-spin-nested-loading {
      &:last-of-type {
        min-height: calc(100vh - 66px);
      }
    }
  }

  .vendor-page__vendor-details {
    top: 66px !important;

    & > div {
      position: fixed;
      width: 596px;
    }
  }
`;

const StyledVendorsPageContent = styled.div`
  padding: 24px;
  justify-content: left;
  position: relative;
  overflow: hidden;
  transition: .2s ease;
`;


const StyledDeleteVendorModalContent = styled.div`
  p {
    color: ${props => props.theme.colors.neutral_7};
    font-size: 14px;
    line-height: 22px;
    max-width: 290px;

    &:nth-of-type(1) {
      color: ${props => props.theme.colors.neutral_10};
      margin-bottom: 10px;
      font-size: 16px;
    }
  }
`;


export {
  StyledVendorsPageContainer,
  StyledVendorsPageContent,
  StyledDeleteVendorModalContent,
}
